<template lang="pug">
.sticky.z-index-10.ui-bright
  .ui-design__container.transparent.py-10.px-2.mx-auto.d-flex.align-center.justify-center.gap-16
    layout-header-navigation.flex-1
    template(v-if="$user.isAuthenticated")
      layout-header-notifications(v-if="!$user.isAdmin")
      layout-header-user-data
    template(v-else)
      layout-header-user-auth
</template>

<script>
import LayoutHeaderNavigation from './LayoutHeaderNavigation.vue';
import LayoutHeaderUserData from './LayoutHeaderUserData.vue';
import LayoutHeaderNotifications from './LayoutHeaderNotifications.vue';
import LayoutHeaderUserAuth from './LayoutHeaderUserAuth.vue';

export default {
  components: {
    LayoutHeaderNavigation,
    LayoutHeaderUserData,
    LayoutHeaderNotifications,
    LayoutHeaderUserAuth,
  },
  props: {},
  computed: {},
};
</script>
